(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-product-slider"] && !Shopify.designMode) return;
  try {
    
  function initBannerSliderModules() {
    document.querySelectorAll('.js-banner-product-slider').forEach((section) => {
      if (section.classList.contains('initialized')) return;
      section.classList.add('initialized');

      /* ── Countdown ── */
      const timerContainer = section.querySelector('.banner__countdown');
      if (timerContainer) {
        const defaultHours = parseInt(timerContainer.dataset.hoursDefault) || 12;
        const showDays     = timerContainer.dataset.showDays === 'true';
        const daysEl       = timerContainer.querySelector('.data-days');
        const hoursEl      = timerContainer.querySelector('.data-hours');
        const minutesEl    = timerContainer.querySelector('.data-minutes');
        const secondsEl    = timerContainer.querySelector('.data-seconds');

        let targetTimestamp = localStorage.getItem(`countdown_target_${section.id}`);
        const resetTimer = () => {
          const t = Date.now() + defaultHours * 60 * 60 * 1000;
          localStorage.setItem(`countdown_target_${section.id}`, t);
          return t;
        };
        if (!targetTimestamp || Date.now() >= parseInt(targetTimestamp)) {
          targetTimestamp = resetTimer();
        } else {
          targetTimestamp = parseInt(targetTimestamp);
        }

        const updateClock = () => {
          let remaining = targetTimestamp - Date.now();
          if (remaining <= 0) { targetTimestamp = resetTimer(); remaining = targetTimestamp - Date.now(); }
          const totalSeconds = Math.floor(remaining / 1000);
          const days    = Math.floor(totalSeconds / (3600 * 24));
          const hours   = showDays ? Math.floor((totalSeconds % (3600 * 24)) / 3600) : Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          if (daysEl)    daysEl.textContent    = String(days).padStart(2, '0');
          if (hoursEl)   hoursEl.textContent   = String(hours).padStart(2, '0');
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
        };
        updateClock();
        setInterval(updateClock, 1000);
      }

      /* ── Slider ── */
      const wrapper  = section.querySelector('.slider-track-container');
      const track    = section.querySelector('.slider-track');
      const slides   = section.querySelectorAll('.slider-slide-item');
      if (!wrapper || !track || slides.length === 0) return;

      const isAutoplay    = wrapper.dataset.autoplay === 'true';
      const isPauseHover  = wrapper.dataset.pauseOnHover === 'true';
      const isInfinite    = wrapper.dataset.infinite === 'true';
      const prevBtn       = section.querySelector('.arrow-prev');
      const nextBtn       = section.querySelector('.arrow-next');
      const dotsContainer = section.querySelector('.slider-pagination-dots');

      let currentIndex  = 0;
      let autoplayTimer = null;

      const getVisibleCount = () => {
        if (window.innerWidth >= 990) return parseFloat(wrapper.dataset.desktopItems);
        if (window.innerWidth >= 750) return parseFloat(wrapper.dataset.tabletItems);
        return parseFloat(wrapper.dataset.mobileItems);
      };
      const getGap = () => window.innerWidth < 749 ? 10 : 15;

      const updateSliderPosition = () => {
        let maxIndex = Math.max(0, slides.length - Math.ceil(getVisibleCount()));
        if (currentIndex > maxIndex) currentIndex = isInfinite ? 0 : maxIndex;
        if (currentIndex < 0)        currentIndex = isInfinite ? maxIndex : 0;
        const slideWidth = slides[0].getBoundingClientRect().width;
        const offset     = currentIndex * (slideWidth + getGap());
        track.style.transform = `translateX(-${offset}px)`;
        updateDots();
      };

      const setupDots = () => {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        const count = Math.max(1, slides.length - Math.floor(getVisibleCount()) + 1);
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('div');
          dot.classList.add('slider-dot');
          if (i === currentIndex) dot.classList.add('active');
          dot.addEventListener('click', () => { currentIndex = i; updateSliderPosition(); });
          dotsContainer.appendChild(dot);
        }
      };

      const updateDots = () => {
        if (!dotsContainer) return;
        dotsContainer.querySelectorAll('.slider-dot').forEach((d, i) =>
          d.classList.toggle('active', i === currentIndex)
        );
      };

      const startAutoplay = () => {
        if (!isAutoplay) return;
        autoplayTimer = setInterval(() => {
          const maxIndex = Math.max(0, slides.length - Math.ceil(getVisibleCount()));
          currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
          updateSliderPosition();
        }, 4000);
      };
      const stopAutoplay = () => clearInterval(autoplayTimer);

      if (nextBtn) nextBtn.addEventListener('click', () => { currentIndex++; updateSliderPosition(); });
      if (prevBtn) prevBtn.addEventListener('click', () => { currentIndex--; updateSliderPosition(); });

      if (isPauseHover) {
        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
      }

      window.addEventListener('resize', () => { setupDots(); updateSliderPosition(); });

      setupDots();
      updateSliderPosition();
      startAutoplay();
    });
  }

  document.addEventListener('DOMContentLoaded', initBannerSliderModules);
  document.addEventListener('shopify:section:load', initBannerSliderModules);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
